export default __webpack_public_path__ + "static/media/checkmark.cf7ac954.svg";